<template>
  <div id="dashboard-component">
    <header id="header" class="flex">
      <div class="logo">
        <router-link to="/" class="hidden-xs icon-saxx-logo" />
      </div>

      <Nav />
    </header>

    <main id="main">
      <section id="content">
        <router-view />
      </section>
    </main>
  </div>
</template>

<script>
  import Nav from './Nav';

  export default {
      name: 'Layout',
      components: {
        Nav,
      },
      // TODO: (╯°□°)╯︵ ┻━┻
      // This is terrible and I, Tony Barry, at the
      // discretion of my manager, Hans Anderson,
      // feel great shame for myself and my family.
      //
      // This is working around a lot of already
      // very messy CSS.
      created() {
        document.body.classList.add('dashboard');
      },
      destroyed() {
        document.body.classList.remove('dashboard');
      },
  }
</script>

<style scoped>
  .flex {
    display: flex;
  }
</style>
